import React from 'react';
import { Route, Switch } from 'react-router-dom';
import GeoAIRequestsList from '@/containers/GeoAI/components/RequestsList';
import GeoAIRequestLimitsList from '@/containers/GeoAI/components/RequestLimits';


export default () => (
  <Switch>
    <Route path="/geoai/requests" component={GeoAIRequestsList} />
    <Route path="/geoai/limits" component={GeoAIRequestLimitsList} />
  </Switch>
);
